/* Eargasm accessibility fixes: labels, alt text, keyboard support. Added 2026-09.
   Rollback: remove {% render 'ea-a11y' %} from sections/static-footer.liquid. */
(function(){
  'use strict';
    function rgb(s){var m=s&&s.match(/\d+(\.\d+)?/g);return m?m.map(Number):null}
  function isCyan(c){return c&&c[0]<80&&c[1]>180&&c[2]>200}

  function openUserWay(e){ if(e){e.preventDefault();} try{ if(window.UserWay&&UserWay.widgetOpen){UserWay.widgetOpen();} }catch(err){} }

  function fix(root){
    root=root||document;
    // 1. Accessibility (UserWay) trigger: real, labeled, keyboard-usable button
    root.querySelectorAll('img[src*="Copy_of_Copy_of_Accessibility"]').forEach(function(img){
      img.setAttribute('alt','');
      var a=img.closest('a');
      if(a&&!a.dataset.eaA11y){
        a.dataset.eaA11y='1';
        a.setAttribute('role','button');
        a.setAttribute('aria-label','Open accessibility menu');
        a.classList.add('ea-a11y-trigger');
        a.addEventListener('click',openUserWay);
        a.addEventListener('keydown',function(e){ if(e.key===' '||e.key==='Spacebar'){openUserWay(e);} });
      }
    });
    // 2. Account icon link
    root.querySelectorAll('a.account-options').forEach(function(a){
      if(!a.getAttribute('aria-label')&&!(a.innerText||'').trim()){a.setAttribute('aria-label',/\/account\/login/.test(a.getAttribute('href')||'')?'Log in to your account':'Your account');}
    });
    // 3. Product quantity input
    root.querySelectorAll('input[name="quantity"]').forEach(function(q){
      if(!q.getAttribute('aria-label')&&!(q.labels&&q.labels.length)){q.setAttribute('aria-label','Quantity');}
    });
    // 4. TargetBay review photos and vote links
    root.querySelectorAll('img[src*="tb-list.com"]:not([alt])').forEach(function(img){img.setAttribute('alt','Customer review photo');});
    root.querySelectorAll('a[href="javascript:void(0)"]').forEach(function(a){
      if(a.getAttribute('aria-label')||(a.innerText||'').trim()) return;
      var img=a.querySelector('img');
      if(img&&img.getAttribute('alt')) return;
      var svg=a.querySelector('svg');
      var cls=svg?(svg.innerHTML||''):'';
      if(/smile-happy/.test(cls)) a.setAttribute('aria-label','Mark this review as helpful');
      else if(/hate-happy/.test(cls)) a.setAttribute('aria-label','Mark this review as not helpful');
      else if(img) a.setAttribute('aria-label','View customer review photo');
      else if(a.closest('[class*="tb-"],[class*="targetbay"],[id^="tb"],[id*="popupProductComment"]')) a.setAttribute('aria-label','Review action');
      a.setAttribute('role','button');
    });
    // 5. Iframes without a title (product video etc.)
    root.querySelectorAll('iframe:not([title])').forEach(function(f){
      var s=(f.getAttribute('src')||'')+' '+(f.className||'');
      f.setAttribute('title',/spotlightr|youtube|vimeo|video/i.test(s)?'Product video':'Embedded content');
    });
    // 6. Product image slider arrows
    root.querySelectorAll('.pmslider-arrows_area[aria-label]:not([role])').forEach(function(d){
      d.setAttribute('role','button');
      if(!d.dataset.eaA11y){d.dataset.eaA11y='1';d.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();d.click();}});}
    });
    // 7. Pagination list with non-li children
    root.querySelectorAll('ul.lh-pagination > :not(li)').forEach(function(el){el.setAttribute('role','listitem');});
    // 8. Cyan text in product descriptions -> black (via class)
    root.querySelectorAll('.rte [style*="color"], .description [style*="color"]').forEach(function(el){
      if(el.classList.contains('ea-a11y-dark')) return;
      if(isCyan(rgb(getComputedStyle(el).color))) el.classList.add('ea-a11y-dark');
    });
    // 9. Homepage React build renders inside a shadow root: inject contrast fixes there
    var host=document.getElementById('eargasm-home-root');
    if(host&&host.shadowRoot&&!host.shadowRoot.querySelector('style[data-ea-a11y]')){
      var st=document.createElement('style'); st.setAttribute('data-ea-a11y','1');
      st.textContent='a[class*="bg-[#FA1D96]"],button[class*="bg-[#FA1D96]"],a[class*="bg-[#FA1D96]"] *,button[class*="bg-[#FA1D96]"] *{color:#000 !important}'+
        '.text-white\\/35{color:rgba(255,255,255,.6) !important}';
      host.shadowRoot.appendChild(st);
    }
  }


  // ---- v2 (full-site sweep) ----
  function txt(el){return ((el&&el.innerText)||'').replace(/\s+/g,' ').trim();}
  function hasName(el){ if(el.getAttribute('aria-label')||el.getAttribute('aria-labelledby')||el.getAttribute('title')) return true; if(txt(el)) return true; var i=el.querySelector('img[alt]:not([alt=""]),svg[aria-label],[aria-label]'); return !!i; }
  function pageTitle(){ var m=document.querySelector('meta[property="og:title"]'); return (m&&m.content)||document.title.split(/[|–-]/)[0].trim(); }
  function fileAlt(src){
    try{ var f=decodeURIComponent((src||'').split('?')[0].split('/').pop()).replace(/\.[a-z0-9]+$/i,'');
      f=f.replace(/_[0-9a-f]{8}-[0-9a-f-]{20,}$/i,'').replace(/[_-]+/g,' ').replace(/\b(copy of|final|v\d+|\d{3,}x\d{3,})\b/gi,' ').replace(/\s+/g,' ').trim();
      var letters=(f.match(/[a-z]/gi)||[]).length;
      if(letters<3||/^[0-9a-f ]{8,}$/i.test(f)) return pageTitle();
      return f;
    }catch(e){return pageTitle();}
  }
  function hostLabel(href){
    var h=href||''; var net=/facebook/.test(h)?'Facebook':/twitter|x\.com/.test(h)?'X (Twitter)':/instagram/.test(h)?'Instagram':/pinterest/.test(h)?'Pinterest':/tiktok/.test(h)?'TikTok':/youtube/.test(h)?'YouTube':/mailto:/.test(h)?'Email':null;
    if(net) return /share|sharer|intent|pin\/create/.test(h)?'Share on '+net:'Eargasm on '+net;
    return null;
  }
  function eachRoot(fn){ fn(document); document.querySelectorAll('*').forEach(function(el){ if(el.shadowRoot) fn(el.shadowRoot); }); }
  function fix2(){
    eachRoot(function(root){
      // selects (incl. subscription widget shadow DOM)
      root.querySelectorAll('select').forEach(function(s){ if(s.getAttribute('aria-label')||(s.labels&&s.labels.length)||s.getAttribute('aria-labelledby')) return; s.setAttribute('aria-label',/selling-plan/.test(s.getAttribute('data-ref')||s.name||'')?'Purchase option':'Select an option'); });
      // images without alt
      root.querySelectorAll('img:not([alt])').forEach(function(img){
        var src=img.getAttribute('src')||'';
        var wrap=img.closest('a,button,[role="button"]');
        if(/no-image|^data:image\/gif/.test(src)||(wrap&&txt(wrap))) img.setAttribute('alt','');
        else img.setAttribute('alt',fileAlt(src));
      });
      // inputs without a label
      root.querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]),textarea').forEach(function(i){
        if(i.getAttribute('aria-label')||i.getAttribute('aria-labelledby')||(i.labels&&i.labels.length)||i.getAttribute('title')) return;
        var c=i.className||''; var l=/date-from/.test(c)?'Reviews from date':/date-to/.test(c)?'Reviews to date':i.getAttribute('placeholder')||(i.type==='email'?'Email address':i.type==='search'?'Search':null);
        if(l) i.setAttribute('aria-label',l);
      });
    });
    // links without a name
    document.querySelectorAll('a[href]').forEach(function(a){
      if(hasName(a)) return;
      var href=a.getAttribute('href')||'';
      var item=a.closest('.rebuy-addon__item,.rebuy-product-block');
      var t=item&&txt(item.querySelector('.rebuy-addon__item-product-title,.rebuy-product-title,[class*="title"]'));
      var l=t?('Learn more about '+t):hostLabel(href);
      if(!l&&a.closest('.lh-popup-sidebar')) l='Toggle sidebar';
      if(!l&&(href==='#'||href==='')){ a.setAttribute('aria-hidden','true'); a.setAttribute('tabindex','-1'); return; }
      if(!l&&/^javascript/.test(href)) l='Open';
      if(!l){ try{ var p=new URL(href,location.href); l=(p.pathname.split('/').filter(Boolean).pop()||p.hostname).replace(/[-_]+/g,' '); }catch(e){ l='Link'; } }
      a.setAttribute('aria-label',l);
    });
    // buttons / role=button without a name
    document.querySelectorAll('button,[role="button"]').forEach(function(b){
      if(hasName(b)) return;
      var c=(b.className&&b.className.baseVal!==undefined?b.className.baseVal:b.className)||'';
      var l=null;
      if(/owl-prev/.test(c)) l='Previous slide'; else if(/owl-next/.test(c)) l='Next slide';
      else if(/owl-dot/.test(c)){ var i=Array.prototype.indexOf.call(b.parentNode.children,b)+1; l='Go to slide '+i; }
      else if(b.hasAttribute('data-replo-decrease-product-quantity')) l='Decrease quantity';
      else if(b.hasAttribute('data-replo-increase-product-quantity')) l='Increase quantity';
      else { var dir=(b.getAttribute('data-replo-direction')||b.getAttribute('data-direction')||c); l=/prev|left|back/i.test(dir)?'Previous':/next|right|forward/i.test(dir)?'Next':null; }
      if(!l&&b.hasAttribute('data-replo-part')) l=/nav/.test(b.getAttribute('data-replo-part'))?'Carousel navigation':'Select';
      if(l) b.setAttribute('aria-label',l);
    });
    // options / listboxes without a name
    document.querySelectorAll('[role="option"]').forEach(function(o){ if(hasName(o)) return; var img=o.querySelector('img'); o.setAttribute('aria-label',(img&&img.getAttribute('alt'))||o.getAttribute('data-value')||'Option'); });
    document.querySelectorAll('[role="listbox"]').forEach(function(o){ if(!o.getAttribute('aria-label')&&!o.getAttribute('aria-labelledby')) o.setAttribute('aria-label','Product options'); });
    // aria-label on plain div/span that is focusable -> role button
    document.querySelectorAll('div[aria-label][tabindex]:not([role]),span[aria-label][tabindex]:not([role]),div[aria-label][onclick]:not([role]),span[aria-label][onclick]:not([role])').forEach(function(d){ d.setAttribute('role', d.querySelector('a[href],button,input,select,textarea,[tabindex]')?'group':'button'); });
    document.querySelectorAll('button [role="button"], a[href] [role="button"]').forEach(function(d){ d.removeAttribute('role'); d.removeAttribute('tabindex'); });
    document.querySelectorAll('div[role="button"][data-rid]').forEach(function(d){ if(hasName(d)) return; var sib=Array.prototype.filter.call(d.parentElement.children,function(x){return x.getAttribute('role')==='button'&&x.hasAttribute('data-rid');}); var i=sib.indexOf(d); d.setAttribute('aria-label', sib.length===2?(i===0?'Previous slide':'Next slide'):'Carousel control'); });
    // Essentials bundle choice buttons: toggle buttons, not radios
    document.querySelectorAll('button.ea-ess__btn[role="radio"][aria-pressed]').forEach(function(b){ b.removeAttribute('role'); });
    // lists: non-li children of ul/ol, and li outside a list
    document.querySelectorAll('ul > ul, ul > ol, ol > ul, ol > ol').forEach(function(n){ var pv=n.previousElementSibling; if(pv&&pv.tagName==='LI'){ n.removeAttribute('role'); pv.appendChild(n); } });
    document.querySelectorAll('ul,ol').forEach(function(u){
      if(u.getAttribute('role')) return;
      Array.prototype.slice.call(u.children).forEach(function(ch){
        if(/^(LI|SCRIPT|TEMPLATE)$/.test(ch.tagName)||ch.getAttribute('role')) return;
        var dl=Array.prototype.filter.call(ch.children,function(x){return x.tagName==='LI';});
        if(dl.length){ var st=ch.getAttribute('style'); dl.forEach(function(li){ if(st&&!li.getAttribute('style')) li.setAttribute('style',st); u.insertBefore(li,ch); }); if(!ch.textContent.trim()) ch.remove(); else ch.setAttribute('role','listitem'); }
        else ch.setAttribute('role','listitem');
      });
    });
    document.querySelectorAll('ul > li[role="presentation"], ol > li[role="presentation"], ul > li[role="none"], ol > li[role="none"]').forEach(function(li){ if(!li.parentElement.getAttribute('role')) li.removeAttribute('role'); });
    document.querySelectorAll('li').forEach(function(li){ var p=li.parentElement; if(!p||/^(UL|OL|MENU)$/.test(p.tagName)||p.getAttribute('role')) return; if(p.getAttribute('role')==='none'){return;} if(!li.getAttribute('role')) li.setAttribute('role','none'); });
  }
  // generic contrast repair: darken (or lighten) the same color until WCAG AA is met
  function parse(s){var m=s&&s.match(/[\d.]+/g);if(!m)return null;return [+m[0],+m[1],+m[2],m.length>3?+m[3]:1];}
  function L(c){var a=c.slice(0,3).map(function(v){v/=255;return v<=0.03928?v/12.92:Math.pow((v+0.055)/1.055,2.4)});return 0.2126*a[0]+0.7152*a[1]+0.0722*a[2];}
  function CR(a,b){var x=L(a),y=L(b);return (Math.max(x,y)+0.05)/(Math.min(x,y)+0.05);}
  function blend(f,b){var a=f[3];return [f[0]*a+b[0]*(1-a),f[1]*a+b[1]*(1-a),f[2]*a+b[2]*(1-a),1];}
  function bgOf(el){ var bg=null,be=null,e=el,op=1; while(e&&e.nodeType===1){ var cs=getComputedStyle(e); op*=parseFloat(cs.opacity); if(cs.backgroundImage&&cs.backgroundImage!=='none') return null; var c=parse(cs.backgroundColor); if(c&&c[3]>0){ if(c[3]<0.95) return null; bg=c; be=e; break; } e=e.parentElement; } return {bg:bg||[255,255,255,1],op:op,el:be}; }
  function contrast(){
    var els=document.body.querySelectorAll('*');
    for(var i=0;i<els.length;i++){
      var el=els[i]; if(el.dataset.eaC) continue;
      var tag=el.tagName; if(/^(SCRIPT|STYLE|SVG|PATH|IMG|VIDEO|IFRAME|NOSCRIPT|TEMPLATE|CANVAS)$/i.test(tag)) continue;
      var own=false; for(var n=el.firstChild;n;n=n.nextSibling){ if(n.nodeType===3&&n.nodeValue.trim()){own=true;break;} }
      if(!own&&!/^(INPUT|TEXTAREA|SELECT)$/.test(tag)) continue;
      if(!el.getClientRects().length) continue;
      if(el.closest('[aria-hidden="true"],#eargasm-home-root,.uwy,[class*="userway"]')) continue;
      var cs=getComputedStyle(el); if(cs.visibility==='hidden') continue;
      var info=bgOf(el); if(!info){ el.dataset.eaC='skip'; continue; }
      var fg=parse(cs.color); if(!fg) continue; if(info.op<1) fg=[fg[0],fg[1],fg[2],fg[3]*info.op];
      var eff=blend(fg,info.bg); var size=parseFloat(cs.fontSize), bold=parseInt(cs.fontWeight,10)>=700;
      var need=(size>=24||(bold&&size>=18.66))?3:4.5;
      if(CR(eff,info.bg)>=need){ el.dataset.eaC='ok'; continue; }
      var toward=L(info.bg)>0.4?0:255, c=fg.slice(0,3), a=fg[3], out=null;
      for(var k=1;k<=20;k++){ var t=k/20; var nc=[c[0]+(toward-c[0])*t,c[1]+(toward-c[1])*t,c[2]+(toward-c[2])*t];
        if(CR(blend([nc[0],nc[1],nc[2],a],info.bg),info.bg)>=need+0.15){ out=nc; break; } }
      if(!out&&a<1){ for(var k2=1;k2<=20;k2++){ var t2=k2/20; var nc2=[c[0]+(toward-c[0])*t2,c[1]+(toward-c[1])*t2,c[2]+(toward-c[2])*t2]; if(CR(nc2.concat([1]),info.bg)>=need+0.15){ out=nc2; break; } } }
      if(!out&&info.el&&(info.el===el||el.contains(info.el)||info.el.contains(el))&&info.el!==document.body&&info.el!==document.documentElement&&(info.el===el||info.el.getBoundingClientRect().width<600)){
        var bt=L(eff)>0.5?0:255, bc=info.bg.slice(0,3);
        for(var j=1;j<=20;j++){ var u=j/20; var nb=[bc[0]+(bt-bc[0])*u,bc[1]+(bt-bc[1])*u,bc[2]+(bt-bc[2])*u,1];
          if(CR(blend(fg,nb),nb)>=need+0.15){ info.el.style.setProperty('background-color','rgb('+nb.slice(0,3).map(Math.round).join(',')+')','important'); el.dataset.eaC='fixedbg'; break; } }
        if(el.dataset.eaC==='fixedbg') continue;
      }
      if(!out){ el.dataset.eaC='nofix'; continue; }
      el.style.setProperty('color','rgb('+out.map(Math.round).join(',')+')','important');
      el.dataset.eaC='fixed';
    }
  }

  var pending=false;
  function schedule(){ if(pending) return; pending=true; setTimeout(function(){pending=false; try{fix(document);}catch(e){} try{fix2();}catch(e){} try{contrast();}catch(e){}},400); }
  function start(){
    try{fix(document);}catch(e){} try{fix2();}catch(e){} try{contrast();}catch(e){}
    try{ new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true}); }catch(e){}
    var n=0, iv=setInterval(function(){ schedule(); if(++n>=20) clearInterval(iv); },1000);
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);} else {start();}
})();
